import React, { Component } from "react";
import Modal from "react-responsive-modal";
import ReactPlayer from 'react-player'

class Player extends Component {

    constructor() {
        super();

        this.state = {
            videoError: false,
        }
    }

    errorVideo = (e) => {
        console.log('errorVideo:');
        console.log(e);

        this.setState({ videoError: true });

        console.log(e.target.error.message)
    }

    downloadVideo = () => {
        this.setState({ videoError: false });

        this.props.downloadMovie(this.props.movieData);
    }

    closeModal = () => {
        this.setState({ videoError: false });

        this.props.toggleModal();
    }

    render() {

        console.log('this.props.movieData:');
        console.log(this.props.movieData);

        const { open, toggleModal, freeswinganalysis } = this.props;
        let url = '';
        let urlImage = '';
        if (this.props.movieData) {
            urlImage = 'https://docs.google.com/file/d/' + this.props.movieData.id + '/preview';
            url = 'https://drive.google.com/uc?export=download&id=' + this.props.movieData.id;
            //url = this.props.movieData.webContentLink;
            //url = "https://drive.google.com/uc?export=preview&id=" + this.props.movieData.id;
        }

        //webContentLink: "https://drive.google.com/uc?id=1d1mFD6kK9ZjGEhvFv3te2xUCe3zGUqH9&export=download"

        console.log('url: ' + url);
        console.log(this.props.movieData);

        return (

            <Modal
                open={open}
                onClose={this.closeModal}
                styles={{
                    modal: {
                        backgroundColor: 'black',
                        maxWidth: "unset",
                        width: "97%",
                        height: "97%",
                        padding: "unset"
                    },
                    overlay: {
                        background: "rgba(0, 0, 0, 0.5)"
                    },
                    closeButton: {
                        marginRight: -100,
                        background: "transparent"
                    },
                    closeIcon: {
                    }
                }}
                center
            >
                {this.props.movieData && this.props.movieData.mimeType === "image/png" && <iframe src={urlImage} width="100%" height="100%"></iframe>}

                {this.props.movieData && this.props.movieData.mimeType === "video/mp4" && <video controls autoPlay muted width={"100%"} height={"100%"} onError={this.errorVideo}>
                    <source src={url} type='video/mp4' />
                </video>}
                {this.props.movieData && this.props.movieData.mimeType === "video/quicktime" && <video controls autoPlay muted playsinline width={"100%"} height={"100%"} onError={this.errorVideo}>
                    <source src={url} type='video/quicktime' />
                </video>}

                <div className="CloseModalIcon" onClick={this.closeModal}>
                    <img width={30} height={30} src={"closeicon.png"} />
                </div>

                {this.state.videoError && <div className="ErrorVideoMsg1">
                    <p className="ErrorVideoTitle">  Could not load preview. Please download video!</p>
                </div>}
                {this.state.videoError && <div className="ErrorVideoMsg" onClick={this.downloadVideo}>
                    <img width={140} height={30} src={"errorvideo.png"} />
                </div>}


            </Modal>
        );
    }
}

export default Player;
